import applogo from 'assets/images/choicehotels.jpg'
import SessionConst from 'constants/SessionConst'
import React, { Component } from 'react'
import Modal from 'react-bootstrap/Modal'
import { getBrandLogo } from 'utilities/FormHelper'
import { getSessionItem } from 'utilities/SessionHelper'
import Button from '../../atoms/Button/Button'
import './FormModal.scss'

class FormModal extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showPopover: false
    }
  }

  componentDidUpdate() {
    if (this.state.showPopover) {
      setTimeout(() => this.setState({ showPopover: false }), 1500)
    }
  }

  render() {

    let logo

    const logoImage = getBrandLogo(this.props.hotelInfo)
    let logoClassName = 'form-header-brand'

    if (logoImage) {
      logo = <img className={logoClassName} src={logoImage} />
    } else {
      logo = <img className={logoClassName} src={applogo} />
    }

    let trackingId
    let errorMessage = this.props.errorMessage

    if (this.props.isError) {
      trackingId = getSessionItem(SessionConst.TRACKING_ID)
    }

    return (
      <Modal id={this.props.id} show={this.props.show} backdrop="static" className='modal-main' centered size={this.props.size ? this.props.size : 'lg'}>
        {
          this.props.title
          && <Modal.Header >
            <Modal.Title >
              {this.props.title}
              {this.props.isLoadingIndicator && <span className='blink'>...</span>}
            </Modal.Title>
          </Modal.Header>
        }
        <Modal.Body >
          {
            logo && !this.props.hideLogo &&
            (
              <div className='modal-body-logo'>
                {logo}
                {this.props.hotelInfo && <div className='modal-hotel-code'><b>{this.props.hotelInfo.hotelCode}</b></div>}
              </div>
            )
          }

          <div className='modal-body-content'>
            {this.props.body}
            <br />
            {
              (this.props.isError && !errorMessage)
              && <h5>
                Tracking id: {trackingId}
                <Button role='link' name='Copy'
                  data-trigger='focus'
                  overridedisabledflag='true'
                  onClick={() => {
                    navigator.clipboard.writeText(trackingId)
                    this.setState({
                      showPopover: true
                    })
                  }
                  } />
                {this.state.showPopover && <span className='badge badge-dark'>Copied</span>}
              </h5>
            }
            {
              (this.props.isError && errorMessage)
              && <h5>
                {errorMessage}
              </h5>
            }
          </div>

        </Modal.Body>
        {
          (this.props.proceed || this.props.cancel || this.props.footerBody)
          && <Modal.Footer className='modal-footer'>
            {
              this.props.proceed
              && <Button
                name={this.props.proceedName || 'Proceed'}
                onClick={this.props.proceed}
                overridedisabledflag='true' />
            }
            {
              this.props.cancel
              && <Button
                name={this.props.cancelName || 'Cancel'}
                onClick={this.props.cancel}
                role='secondary'
                overridedisabledflag='true' />
            }
            {
              this.props.footerBody
              && (
                <>
                  <br />
                  <br />
                  {this.props.footerBody}
                </>
              )
            }
          </Modal.Footer>
        }
      </Modal>
    )
  }
}

export default FormModal